var render = function render(){var _vm=this,_c=_vm._self._c;return _c('f7-page',_vm._g(_vm._b({attrs:{"page-content":_vm.pageContent},on:{"page:mounted":function($event){return _vm.Utils.onPageMounted()}}},'f7-page',{..._vm.$attrs,..._vm.$props},false),_vm.$listeners),[_vm._t("default",null,{"page":_vm.self})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }